<template>
  <div v-if="show">
    <div v-if="model && isDisabled" class="button-disabled">
      <img
        v-if="model?.showIcon"
        :src="
          appStore.currentMode() === DisplayMode.Light
            ? iconQuestionMarkLight
            : iconQuestionMarkDark
        "
        :alt="alt"
        :key="componentKey"
      />
      {{ text }}
    </div>

    <div v-if="model && !isDisabled" class="button" @click="click">
      <img
        v-if="model?.showIcon"
        :src="
          appStore.currentMode() === DisplayMode.Light
            ? iconQuestionMarkLight
            : iconQuestionMarkDark
        "
        :alt="alt"
        :key="componentKey"
      />
      {{ text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { ButtonHelp } from '../types/configuration/ButtonHelp'
import { updateComponentKey } from '../composables/ComponentKey'
import iconQuestionMarkLight from '../assets/icons/light/icon-question-mark.svg'
import iconQuestionMarkDark from '../assets/icons/dark/icon-question-mark.svg'
import { DisplayMode } from '../types/app/displayMode'
import { useAppStore } from '../stores/appStore'

const appStore = useAppStore()

const props = defineProps<{
  model: ButtonHelp | undefined
  alt: string | undefined
  text: string | undefined
  show: boolean | undefined
  click: () => void
  isDisabled: boolean
}>()

const isUrlValid = ref(false)
let componentKey = updateComponentKey(props, () => (isUrlValid.value = props.model !== undefined))
</script>

<style scoped lang="scss">
.button {
  background-color: var(--background-color);
  font-family: 'Noto Sans', sans-serif;
  border: 0px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  vertical-align: middle;
}

.button,
.button-disabled {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.button img,
.button-disabled img {
  width: 20px;
  height: 20px;
}
</style>
